import axios from 'axios'
import api from '@/api'

export const shiftPlaningModule = {
    namespaced: true,

    state:() => ({
        isLoading: true,
        shiftRoles: null,
        sections: null,
        stations: null,
        shiftPlanings: null,
    }),

    mutations: {
        setShiftRoles(state, data) {
            state.shiftRoles = data
        },

        setSections(state, data) {
            if(data.length !== 0) {
                state.sections = data
            } else {
                state.sections = null
            }
        },

        setStations(state, data) {
            state.stations = data
        },

        setShiftPlanings(state, data) {
            if(data.length !== 0) {
                state.shiftPlanings = data
                for(let section in data) {
                    if(data[section].roles.length != 0) {
                        for(let i = 0; i < data[section].roles.length; i++) {
                            data[section].roles[i].time_from ? data[section].roles[i].time_from = data[section].roles[i].time_from.substring(0, 5) : null
                            data[section].roles[i].time_to ? data[section].roles[i].time_to = data[section].roles[i].time_to.substring(0, 5) : null
                        }
                    }
                }
            } else {
                state.shiftPlanings = null
            }
        }
    },

    actions: {
        fetchSections({ commit }, data) {
            axios
            .get(`${api}projects/${data.project}/${data.shop}/sections`, {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                commit('setSections', response.data)
            })
            .catch((error) => {
                console.log(error.response);
            });
        },

        fetchStations({ commit }, project) {
            axios
            .get(`${api}projects/${project}/stations/`, {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                console.log(response)
                commit('setStations', response.data)
            })
            .catch((error) => {
                console.log(error);
            });
        },

        async fetchShiftPlanings({ state, commit }, data) {
            return axios
            .get(`${api}projects/${data.project}/${data.shop}/shift-plannings`, {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                console.log(response)
                if(response.status == 200) {
                    commit('setShiftPlanings', response.data)
                    return response.data
                }
                
            })
            .catch((error) => {
                console.log(error);
            });
        },

        createNewSection({ dispatch }, data) {
            axios
            .post(`${api}projects/${data.project}/${data.shop}/shift-plannings/`,
            {
                shop: data.shop,
                revenue: data.revenue,
                efficiency: data.efficiency,
                copy_from: data.copy_from ? data.copy_from : null,
                pay_percent: data.pay_percent
            },
            {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                dispatch('fetchShiftPlanings', { project: data.project, shop: data.shop_code })
            })
            .catch((error) => {
                console.log(error.response);
            });
        },

        async deleteSection({ dispatch }, data) {
            return axios
            .delete(`${api}projects/${data.project}/${data.shop}/shift-plannings/${data.id}/`,
            {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                if(response.status == 204) {
                    return true
                }                
            })
            .catch((error) => {
                console.log(error.response);
            });
        },

        editSection({ dispatch }, data) {
            console.log(data);
            axios
            .put(`${api}projects/${data.project}/${data.shop_code}/shift-plannings/${data.id}/`,
            {
                id: data.id,    
                shop: data.shop,
                revenue: data.revenue,
                pay_percent: data.pay_percent,
                efficiency: data.efficiency,
            },
            {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                dispatch('fetchShiftPlanings', { project: data.project, shop: data.shop_code })
            })
            .catch((error) => {
                console.log(error.response);
            });
        },

        addRow({ dispatch }, data) {
            axios
            .post(`${api}projects/${data.project}/${data.shop}/shift-planning-roles/`,
            {
                description: data.description,
                section: data.section,
                hours: data.hours,
                shift_planning: data.shift_planning,
                station: data.station,
                time_from: data.time_from,
                time_to: data.time_to,
                pay_rate: data.pay_rate
            },
            {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                dispatch('fetchShiftPlanings', { project: data.project, shop: data.shop })
            })
            .catch((error) => {
                console.log(error.response);
            });
        },

        editRow({ dispatch }, data) {

            axios
            .patch(`${api}projects/${data.project}/${data.shop}/shift-planning-roles/${data.id}/`,
            {
                description: data.description,
                section: data.section,
                hours: data.hours,
                shift_planning: data.shift_planning,
                station: data.station,
                time_from: data.time_from,
                time_to: data.time_to,
                pay_rate: data.pay_rate
            },
            {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                dispatch('fetchShiftPlanings', { project: data.project, shop: data.shop })
            })
            .catch((error) => {
                console.log(error.response);
            });
        },

        deleteRow({ dispatch }, data) {
            axios
            .delete(`${api}projects/${data.project}/${data.shop}/shift-planning-roles/${data.id}/`,
            {
                headers: {
                    Authorization: 'Token ' + localStorage.getItem('token')
                }
            })
            .then((response) => {
                dispatch('fetchShiftPlanings', { project: data.project, shop: data.shop })
            })
            .catch((error) => {
                console.log(error.response);
            });
        }
    }
}